// Skeleton Loading
import { LoadingSkeleton } from '../../Components/LoadingSkeleton';
import { SkeletonTypes } from '../../Components/LoadingSkeleton/types';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  setPageShowed,
  setIsBooksLoadingMoreData,
} from '../../app/features/booksSlice';
// hooks
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { useBooks } from '../../hooks/useBooks';
// Components
import Card from '../../Components/Card';
import InternalContainer from '../../Components/InternalContainer';
import Pagination from '../../Components/Pagination';
import FiltersBooks from '../../Components/FiltersBooks';
import SummarySearch from '../../Components/SummarySearch';
// Utils
import { addBooksData } from '../../utils/addBooksData';
// Styles
import './Books.css';
import { FavoriteCategory } from '../FavoriteDetail/types';
import { useAuth } from '../../hooks/useAuth';
// Translate
import { useTranslation } from 'react-i18next';

const BooksPage = () => {
  const { t } = useTranslation();
  const { handleScrollToTop } = useScrollToTop();
  const { isAuth } = useAuth();

  const dispatch = useDispatch();
  const { getBooksDataSocket } = useBooks();
  const { institutionCode } = useSelector((state) => state.institution);
  const {
    books,
    totalBooks,
    filters,
    pageShowed,
    isBooksLoading,
    queryFetched,
  } = useSelector((state) => state.books);

  // Pagination
  const itemsPerPage = 12;

  // Resultados para pagina actual
  const indexOfLastItem = pageShowed * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = books.slice(indexOfFirstItem, indexOfLastItem);
  const currentItems =
    books.length > 0
      ? addBooksData(books, queryFetched, institutionCode).slice(
          indexOfFirstItem,
          indexOfLastItem
        )
      : [];
  const totalPages = Math.ceil(totalBooks / itemsPerPage);

  // Resultados para siguiente pagina
  const indexOfLastItemNext = (pageShowed + 1) * itemsPerPage;
  const indexOfFirstItemNext = indexOfLastItemNext - itemsPerPage;
  const nextItems = books.slice(indexOfFirstItemNext, indexOfLastItemNext);

  const handlePageChange = (newPage) => {
    handleScrollToTop(400);
    if (newPage > pageShowed) {
      if (
        pageShowed < totalPages ||
        (Math.ceil(books?.length / itemsPerPage) > 1 && totalPages === 0)
      ) {
        dispatch(setPageShowed(newPage));
        if (nextItems.length < itemsPerPage) {
          dispatch(setIsBooksLoadingMoreData(true));
          getBooksDataSocket(
            filters.queryFetched,
            filters.pageFetched + 1,
            filters.startYearFetched,
            filters.endYearFetched,
            filters.sourcesFetched,
            filters.keywordsFetched,
            filters.authorsFetched,
            filters.topicFetched,
            filters.languageFetched
          );
        }
      }
    } else {
      if (pageShowed > 1) {
        dispatch(setPageShowed(newPage));
      }
    }
  };

  return (
    <>
      {isBooksLoading && (
        <main className='books-content'>
          <InternalContainer>
            <section className='results'>
              {Array.from({ length: 10 }).map((_, i) => (
                <LoadingSkeleton key={i} type={SkeletonTypes.LIBRARY_CARD} />
              ))}
            </section>
          </InternalContainer>
        </main>
      )}

      {!isBooksLoading && books?.length > 0 && (
        <main className='books-content'>
          <InternalContainer>
            <div className='summaryContainer'>
              <SummarySearch total={totalBooks} />
              <FiltersBooks />
            </div>

            <section>
              <div className='results'>
                {currentItems?.map((libraryItem, i) => (
                  <Card
                    key={i}
                    title={libraryItem?.title}
                    authors={libraryItem?.authors}
                    abstract={libraryItem?.abstract}
                    publication_date={libraryItem?.publication_date}
                    url={libraryItem?.url}
                    type={t('Book')}
                    resource_origin={
                      libraryItem?.source_code
                        ? libraryItem.source_code.replace('_', ' ')
                        : 'No data source'
                    }
                    peer_reviewed={libraryItem?.peer_reviewed}
                    favoriteCategory={FavoriteCategory.BOOKS}
                    showFavoriteButton={isAuth()}
                  />
                ))}
              </div>

              <Pagination
                pageShowed={pageShowed}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </section>
          </InternalContainer>
        </main>
      )}

      {!isBooksLoading && totalBooks === 0 && queryFetched.length === 0 && (
        <main className='noDataContainerBooks'>
          <InternalContainer className='no-data'>
            <p>{t('Please enter a search term')}</p>
          </InternalContainer>
        </main>
      )}

      {!isBooksLoading && books?.length === 0 && queryFetched.length > 0 && (
        <main className='noDataContainerBooks'>
          <InternalContainer className='no-data'>
            <p>{t('No data found')}</p>
          </InternalContainer>
        </main>
      )}
    </>
  );
};

export default BooksPage;
